// test1490
(1490 && 0);
